import { render, staticRenderFns } from "./order_pending.vue?vue&type=template&id=407c337d&scoped=true"
import script from "./order_pending.vue?vue&type=script&lang=js"
export * from "./order_pending.vue?vue&type=script&lang=js"
import style0 from "./order_pending.vue?vue&type=style&index=0&id=407c337d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c337d",
  null
  
)

export default component.exports